//Libraries
import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import moment from 'moment';


// Local Libraries
import phrasebookLoad from "../../i18n";
import * as token from '../../helpers/token';
import { accountTypesConstants, portalFunctionalityConstants, permissionTypeConst } from '../../constants';
import { capitalizeFirstLetter, permissionFinder } from "../../helpers/util"
import { DatePicker } from "../../components/SkyFramework/DatePicker/DatePicker";

//Redux
import { callActions, filedownloadActions, vendorActions, alertActions } from 'actions';

//Componenets
import { Table } from "../../components/SkyFramework/Tables/Table.jsx";
import { PaginationBar } from "../../components/SkyFramework/Pagination/PaginationBar.jsx";
import { NewBreadcrumbs } from "../../components/SkyFramework/Breadcrumbs/NewBreadcrumbs";
import { SearchBox } from "../../components/SkyFramework/Search";
import { OnClickButton } from "../../components/SkyFramework/Buttons";


//Routes
import { gisRoutes } from "../../routes/routes";

// Constants
const phrasebook = phrasebookLoad()

class Calls extends React.Component {
  constructor(props) {
    super(props);
    var dateToday = new Date();
    this.state = {
      calls: undefined,
      service_types: [{ value: 'ITFS', label: 'ITFS' }, { value: 'UIFN', label: 'UIFN' }, { value: 'DID', label: 'DID' }, { value: 'SIP Trunking', label: 'SIP Trunking' }],
      periods: [{ value: 7, label: '7 days' }, { value: 14, label: '14 days' }, { value: 30, label: '30 days' }, { value: 90, label: '90 days' }],
      directions: [{ value: 'INBOUND', label: 'Inbound' }, { value: 'OUTBOUND', label: 'Outbound' }],
      customers: undefined,
      jurisdictions: undefined,
      cities: undefined,
      service_type: undefined,
      jurisdiction: undefined,
      customer_code: token.loggedProperty('customer_code'),

      dateToday: dateToday,
      toDate: moment(new Date),
      fromDate: moment(new Date).subtract(1, 'days'),
      direction: undefined,
      period: 7,
      filters: { orderby: 'CDR_DISCTIME_DAY' },
      city: undefined,
      routing_vendor: undefined,
      // order_id: undefined,
      // filters: { orderby: 'jurisdiction', asc: true },
      limit: 10,
      page: 1
    };

    this.account_type_logged = accountTypesConstants[token.loggedAccountType()];
    this.handleSearchSubmit = this.handleSearchSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleCallSearch = this.handleCallSearch.bind(this);

    // this.handleDeleteSubmit = this.handleDeleteSubmit.bind(this);
  }

  handleCallSearch() {
    var format = 'YYYY-MM-DD';
    var searchValues = {
      customer_code: this.state.customer_code,
      jurisdiction: this.state.jurisdiction,
      service_type: this.state.service_type,
      toDate: moment(this.state.toDate).format(format),
      fromDate: moment(this.state.fromDate).format(format),
      direction: this.state.direction,
      orderby: 'CDR_DISCTIME_DAY',
    };
    this.setState({ calls: undefined });
    this.setState({ filters: searchValues });
    this.props.dispatch(callActions.getAll(this.state.limit, 0, searchValues));
  }

  componentDidMount() {

    if (token.loggedAccountType() < 200) {
      this.props.dispatch(vendorActions.getAll(0, this.state.page, { orderby: 'name', asc: true }));
    }
    this.props.dispatch(callActions.getJurisdictions());
    this.props.dispatch(callActions.getCities());
    this.handleCallSearch()
  }

  componentDidUpdate(prevProps) {
    if (this.props.customers && prevProps && prevProps.customers !== this.props.customers) {
      this.setState({ customers: this.props.customers.data });
    }
    if (this.props.calls && prevProps && prevProps.calls !== this.props.calls) {
      this.setState({ calls: this.props.calls });
    }
    if (this.props.cities && prevProps && prevProps.cities !== this.props.cities) {
      this.setState({ cities: this.props.cities });
    }
    if (this.props.jurisdictions && prevProps && prevProps.jurisdictions !== this.props.jurisdictions) {
      this.setState({ jurisdictions: this.props.jurisdictions });

    }
  }

  onPageChanged = currentPage => {
    this.setState({ page: currentPage });
    //this.state.filters
    this.props.dispatch(callActions.getAll(this.state.limit, currentPage - 1, this.state.filters));
  }

  handlePickerChange = (id) => (date) => {
    if (id == 'fromDate') {
      if (date > this.state.toDate) alertActions.error('Please select a date before the `To date` ');
      else this.setState({ [id]: date });
    } else if (id == 'toDate') {
      if (date < this.state.fromDate) alertActions.error('Please select a date after the `From date` ');
      else this.setState({ [id]: date });
    }
  }

  handleChange(e) {
    const { id, name, value } = e.target;
    if (id) this.setState({ [id]: value });
    else if (name) this.setState({ [name]: value });
  }

  handleSearchSubmit = (e) => {
    e.preventDefault();
    this.handleCallSearch()
  }

  handleDownload = (e) => {
    e.preventDefault();
    this.props.dispatch(filedownloadActions.add('calls', 'callsummary', this.state.limit, 0, this.state.filters));

  }

  SearchBox() {

    if (this.state.jurisdictions && this.state.cities) {
      if (token.loggedAccountType() < 200 && this.state.customers) {
        const customerOptions = this.state.customers.map(function (customer) {
          return { value: customer['pccwglobal_insight_company_code'] ? customer['pccwglobal_insight_company_code'] : customer['name'], label: capitalizeFirstLetter(customer['name']) };
        });
        var filters = [[{ label: phrasebook.common.customer, type: "select", id: "customer_code", name: "customer_code", options: customerOptions, empty_option: true }, {
          label: phrasebook.numbers.type_of_service,
          type: "select",
          id: "service_type",
          name: "service_type",
          options: this.state.service_types,
          empty_option: true,
        }]]
      } else {
        var filters = [[{
          label: phrasebook.numbers.type_of_service,
          type: "select",
          id: "service_type",
          name: "service_type",
          options: this.state.service_types,
          empty_option: true,
        }]]
      }

      const jurisdictionOptions = this.state.jurisdictions.length > 0 ? this.state.jurisdictions.map(function (jurisdiction) {
        return { value: jurisdiction.jurisdiction, label: jurisdiction.jurisdiction };
      }) : [];
      const cityOptions = this.state.cities.length > 0 ? this.state.cities.map(function (city) {
        return { value: city.city, label: city.city };
      }) : [];

      filters.push([
        { label: phrasebook.profile.jurisdiction, type: "select", id: "jurisdiction", tooltip: phrasebook.tooltip.jurisdiction, name: "jurisdiction", options: jurisdictionOptions, empty_option: true },
        { label: phrasebook.references.city, type: "select", id: "city", name: "city", options: cityOptions, empty_option: true },
        { label: phrasebook.common.direction, type: "select", id: "direction", name: "direction", options: this.state.directions, empty_option: true }
      ])

      filters.push([
        <DatePicker
          label={"From date"}
          value={this.state.fromDate}
          maxDate={moment()}
          minDate={moment().subtract(30, "days")}
          onChange={this.handlePickerChange('fromDate')}
        />,
        <DatePicker
          label={"To date"}
          value={this.state.toDate}
          maxDate={moment()}
          minDate={moment().subtract(30, "days")}
          onChange={this.handlePickerChange('toDate')}
        />
      ])

      return (
        <SearchBox
          filters={filters}
          buttonTitle={phrasebook.common.search}
          onClick={this.handleSearchSubmit}
          onChange={this.handleChange}
        />)
    } else return null;
  }



  CallList = () => {

    if (this.state.calls) {
      let labels = [
        'CDR_SEIZTIME',
        'SERVICE_TYPE',
        'CUSTOMER',
        'CDR_CLDNUM',
        'CDR_CLGNUM',
        'CDR_CLDCNUM',
        'CDR_ORIGIN',
        'CDR_DESTINATION',
        'CDR_DISCTIME', 'CDR_COMPCODE', 'CDR_RELEASEDIR', 'CDR_IC_CUSTOMER_NAME', 'CDR_OG_CUSTOMER_NAME'
      ];
      var fields = ['CDR_SEIZTIME', 'SERVICE_TYPE', ['vendor', 'name'],
        'CDR_CLDNUM', 'CDR_CLGNUM', 'CDR_CLDCNUM', 'CDR_ORIGIN', 'CDR_DESTINATION', 'CDR_DISCTIME', 'CDR_COMPCODE', 'CDR_RELEASEDIR', 'CDR_IC_CUSTOMER_NAME', 'CDR_OG_CUSTOMER_NAME']
      var actions = [];

      // actions.push({
      //   location: gisRoutes.management.call.read,
      //   label: phrasebook.common.show,
      //   type: "link",
      // });
      return (<div>
        <br></br>
        <Table
          headers={labels}
          keys={fields}
          values={this.state.calls.data}
          nofound={phrasebook.common.nodatafound}
        // actions={actions}
        // action_key={'id'}
        />
        <PaginationBar limit={this.state.limit}
          total={this.state.calls.count}
          currentPage={this.state.page}
          onPageChanged={this}
          pageNeighbours={this.state.pageNeighbours} />
      </div>)
    } else return <Loader
      type="TailSpin"
      color="#00BFFF"
      height={100}
      width={100}
    />;
  }

  render() {
    return <>
      <NewBreadcrumbs crumbs={[{ link: gisRoutes.dashboard[this.account_type_logged], label: phrasebook.common.home }]} current={phrasebook.reports.call_records} />

      <div className="box p-1 p-sm-2">
        <h2 className="box-title pb-1 mb-1">{phrasebook.reports.call_records}</h2>
        {this.SearchBox()}
        {/* {this.CallList()} */}
      </div>
      <div className="box p-1 p-sm-2 my-md-1">
        <h3 className="box-title pb-1 mb-1">{phrasebook.headerlinks.calls}</h3>
        {this.state.calls && this.state.calls.count > 0 ? <OnClickButton
          title={'Download'}
          onClick={this.handleDownload}
        /> : null}
        {this.CallList()}
      </div>

    </>
  }
}

function mapStateToProps(state) {
  const { authentication, call, vendor, loggedpermissions } = state;
  const { authUser } = authentication;
  return {
    authUser,
    loggedpermissions,
    customers: vendor.vendors,
    calls: call.calls,
    cities: call.cities,
    jurisdictions: call.jurisdictions,
  };
}

const calls = connect(mapStateToProps)(Calls);
export default calls;
